import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "10 10 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M26.8737 17.5707L22.4293 13.1263L25.0555 10.5001C25.446 10.1096 26.0792 10.1096 26.4697 10.5001L29.5 13.5303C29.8905 13.9208 29.8905 14.554 29.5 14.9445L26.8737 17.5707ZM11.469 27.3671L12.2071 23.3488L21.3182 14.2377L25.7626 18.6822L16.6515 27.7933L12.6332 28.5313C12.5719 28.5426 12.5113 28.5481 12.4518 28.5482L11.4142 29.5859C11.2816 29.7185 11.1017 29.793 10.9142 29.793C10.5237 29.793 10.2071 29.4764 10.2071 29.0859C10.2071 28.8983 10.2816 28.7185 10.4142 28.5859L11.4521 27.5479C11.4523 27.4886 11.4578 27.4282 11.469 27.3671Z",
		fill: "#707070"
	})
});
export default SvgIconPen;
